import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

const supportsStableVh = () =>
  typeof window !== 'undefined' &&
  window.CSS?.supports?.('height', '100svh')

const setAppHeight = () => {
  const viewportHeight = window.innerHeight
  document.documentElement.style.setProperty('--app-height', `${viewportHeight}px`)
}

if (!supportsStableVh()) {
  setAppHeight()
  window.addEventListener('resize', setAppHeight)
  window.addEventListener('orientationchange', setAppHeight)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
